import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Globals } from '../globals/globals';

@Injectable()
export class UnauthenticatedGuard implements CanActivate {

  constructor(
    public globals: Globals,
    private router: Router
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const hasAccessToken = localStorage.getItem('access_token');
    if ((this.globals.user === undefined) || !hasAccessToken) {
      return true;
    }

    this.router.navigateByUrl('');
    return false;
  }
}
